import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerTimeClockPickerModalResourceBundleEn(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      dateTime: {
        TimeClockPickerModal: {
          cancel: 'cancel',
          finish: 'finish',
          next: 'next',
          previous: 'previous'
        }
      }
    } as Partial<
      Pick<CustomTypeOptions['resources']['record-it-components'], 'dateTime'>
    >,
    true
  );
}
